import React, { createContext, useContext, useEffect, useMemo, useReducer, useRef } from "react";
import { ParentContext } from "../../../../global/cnr/contexts/ParentContext";
import { seasonMatchesHandlers, seasonMatchesInitialState, seasonMatchesReducer } from "../reducers/SeasonMatchesReducer";
import { SportsSeasonContext, matchScheduleTypes } from "./SportsSeasonContext";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";

export const SeasonMatchesContext = createContext()

const _cnEditTypes = {
  allowMatchEdit: 'ame',
  allowScoreEdit: 'ase',
  allowAdminMatchEdit: 'aame'
}

export default function SeasonMatchesProvider(props) {

  // TOURNAMENT
  // tournamentType={tournamentType}
  // poolMatches={matches}
  // pools={pools}
  // poolKey={item_pool}
  // isTournament={true}
  // viewItem={viewItem}
  // handleMatchClick={handleMatchClick}

  // PLAYOFFS
  // poolMatches={matches}
  // pools={pools_init}
  // isTournament={true}
  // viewItem={viewItem}
  // handleMatchClick={handleMatchClick}
  // tournamentType={tournamentType}
  // forPlayoff={true}
  // poolKey={p}

  // matchScheduleDisplayType, scheduleDisplayType

  const {
    commonMatches,
    forBackup,
    forOverview,
    forPlayoff,
    forSummary,
    latestMatchesCount,
    matchScheduleDisplayType,
    matchScheduleType,
    poolKey,
    poolMatches,
    pools,
    previewMatches,
    // scheduleDisplayType,
    teamKey,
    tournamentType,
    directMatches,
  } = props

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state ?? {}

  // sportsSeasonContext
  // const sportsSeasonContext = useContext(SportsSeasonContext)
  // const { sportsSeason_state } = sportsSeasonContext ?? {}
  // const { matches_info, seasonMatches_info, sportPermissions } = sportsSeason_state ?? {}

  // const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info

  const _teamKey = teamKey ? teamKey : pathViews.teams

  const scheduleTypes = {
    district: pathViews && pathViews.districts && !pathViews.matches && !pathViews.sports && !pathViews.teams ? true : false,
    match: pathViews && pathViews.matches ? true : false,
    sport: pathViews && pathViews.sports ? true : false,
    team: teamKey || (pathViews && pathViews.teams) ? true : false,
    common: commonMatches ? true : false
  }

  let _sepBySection = true
  if (scheduleTypes.team || scheduleTypes.match || scheduleTypes.common) {
    _sepBySection = false
  }

  // sidebar
  const init = {
    _teamKey,
    // directMatches,
    commonMatches,
    // latestMatchesCount,
    matchScheduleType,
    // scheduleDisplayType,
    matchScheduleDisplayType,
    // matchesInfo: _matches_info,
    // pathViews,
    previewMatches,
    // scheduleTypes,
    // sepBySection: _sepBySection,
    // sportPermissions,
    // tournamentType,
    // forPlayoff,
    // forSummary
  }

  const [seasonMatches_state, seasonMatches_dispatch] = useReducer(seasonMatchesReducer, seasonMatchesInitialState(init));
  const seasonMatches_handlers = useMemo(
    () => seasonMatchesHandlers(seasonMatches_dispatch),
    [seasonMatches_dispatch]
  );

  const previousRef = useRef(null);

  // update the scheduledMatches
  // useEffect(() => {

  //   const current = {
  //     pathViews,
  //     _matches_info
  //   };

  //   if (!_matches_info) return;

  //   if (_.isEqual(previousRef.current, current)) return;

  //   previousRef.current = _.cloneDeep(current);

  //   console.log('INIT seasonMatchesProvider', _matches_info);

  //   seasonMatches_handlers.handleMatches_init(_matches_info, commonMatches);

  //   // if (_matches_info) {
  //   //   console.log('INIT seasonMatchesProvider', _matches_info, pathViews)
  //   //   seasonMatches_handlers.handleMatches_init(_matches_info, commonMatches)
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps 
  // }, [pathViews, _matches_info]);

  return <SeasonMatchesContext.Provider
    value={{ seasonMatches_state, seasonMatches_handlers }}>
    {props.children}
  </SeasonMatchesContext.Provider>
}